import styled from 'styled-components';

const StyledAmountGhostInput = styled.div`
  .ant-input-prefix {
    color: ${props => props.theme.colors.neutral_6};
  }
  .ant-input-affix-wrapper {
    display: flex;
    justify-content: end;
    flex-direction: row;
  }
  input {
    min-width: 30px;
  }

  .amount-ghost-test {
    position: absolute;
    visibility: hidden;
  }
`;


export {
  StyledAmountGhostInput,
}
